import showdown from "showdown";

showdown.setOption("emoji", true);
showdown.setOption("simpleLineBreaks", true);
showdown.setOption("smoothLivePreview", true);
showdown.setOption("smartIndentationFix", true);
showdown.setOption("strikethrough", true);
showdown.setOption("tables", true);
showdown.setOption("noHeaderId", true);

export const convertMarkdownToHTML = (markdownText: string) => {
  if (markdownText?.length > 0) {
    const converter = new showdown.Converter();
    const htmlText = converter.makeHtml(markdownText) as string;

    return htmlText;
  }

  return "";
};
